export const SEND_OTP_REQUEST = "send_otp_request";
export const SEND_OTP_RESPONSE = "send_otp_response";

export const GOOGLE_LOGIN_REQUEST = "google_login_request";
export const GOOGLE_LOGIN_RESPONSE = "google_login_response";

export const FACEBOOK_LOGIN_REQUEST = "facebook_login_request";
export const FACEBOOK_LOGIN_RESPONSE = "facebook_login_response";

export const MOBILE_NO_LOGIN_REQUEST = "mobile_no_login_request";
export const MOBILE_NO_LOGIN_RESPONSE = "mobile_no_login_response";

export const LOGOUT_REQUEST = "logout_request";
export const LOGOUT_RESPONSE = "logout_response";
